import { DataClassifiers } from '@ariksa/data-scanning/api';

export const DATA_TYPE_COLORS = Array.from(
  { length: 32 },
  (_, index) => `hsl(${Math.round((index * 360) / 32)} 65% 48%)`,
);

export const EMPTY_DATA_TYPE_VALUES = new Set(['', '-']);

export const getDataTypeColor = (
  dataType: string,
  dataTypes: DataClassifiers[] = [],
) => {
  const classifierIndex = dataTypes.findIndex(
    classifier => classifier.name === dataType,
  );
  if (classifierIndex >= 0) {
    return DATA_TYPE_COLORS[classifierIndex % DATA_TYPE_COLORS.length];
  }

  const hash = [...dataType].reduce(
    (total, character) => total + character.charCodeAt(0),
    0,
  );
  return DATA_TYPE_COLORS[hash % DATA_TYPE_COLORS.length];
};

export const getDataTypeDisplayName = (
  dataType: string,
  dataTypes: DataClassifiers[] = [],
) =>
  dataTypes.find(classifier => classifier.name === dataType)?.read_name ||
  dataType;

export const normalizeDataTypes = (value: unknown): string[] => {
  if (value instanceof Set) {
    return Array.from(value).flatMap(item => normalizeDataTypes(item));
  }

  if (Array.isArray(value)) {
    return value.flatMap(item => normalizeDataTypes(item));
  }

  if (typeof value === 'string') {
    const normalizedValue = value.trim();
    return EMPTY_DATA_TYPE_VALUES.has(normalizedValue) ? [] : [normalizedValue];
  }

  if (value && typeof value === 'object') {
    const dataType = value as {
      name?: unknown;
      data_type?: unknown;
      type_name?: unknown;
    };
    const namedValue =
      dataType.name || dataType.data_type || dataType.type_name;

    if (typeof namedValue === 'string') {
      const normalizedValue = namedValue.trim();
      return EMPTY_DATA_TYPE_VALUES.has(normalizedValue)
        ? []
        : [normalizedValue];
    }
  }

  return [];
};
